module.exports = __webpack_public_path__ + "img/tn.544a0fba.svg";